import cn from 'classnames';
import { useEffect } from 'react';
import gtag from '../analytics/gtag';
import { ApiResponseError } from '../api';
import Icon from './Icon';

export type ErrorBoxType = string | { message: string }[] | ApiResponseError | { error: string; error_description: string };

export interface Props {
    errors?: ErrorBoxType | null;
    className?: string;
}

export default function ErrorBox({ errors, className }: Props) {
    if (errors == null) {
        return null;
    }

    return (
        <div className={cn('error-message', className)} aria-live="assertive">
            <Icon className="icon-alert-error" />
            <ErrorMessage errors={errors} />
        </div>
    );
}

function ErrorMessage({ errors }: { errors: ErrorBoxType }) {
    if (errors instanceof ApiResponseError) {
        return <ErrorMessage errors={errors.errors} />;
    } else if (Array.isArray(errors)) {
        if (errors.length > 1) {
            return <Messages messages={errors} />;
        } else {
            return <Message message={errors[0].message} />;
        }
    } else if (typeof errors === 'string') {
        return <Message message={errors} />;
    } else if (errors && typeof errors === 'object' && errors.error_description) {
        return <Message message={errors.error_description} />;
    } else if (errors instanceof Error) {
        return <Message message={errors.message} />;
    } else {
        console.log('ErrorBox not set up to present error of type:', typeof errors);
        console.log(errors);
        return <Message message="Det har oppstått en ukjent feil." />;
    }
}

function Message({ message }: { message: string }) {
    useEffect(() => {
        gtag('event', 'error_message', {
            message,
        });
    }, [message]);

    return <div className="message-text">{message}</div>;
}

function Messages({ messages }: { messages: { message: string }[] }) {
    useEffect(() => {
        gtag('event', 'error_message', {
            message: messages.join('\n'),
        });
    }, [messages]);

    return (
        <ul className="message-text">
            {messages.map((error, i) => (
                <li key={i}>{error.message}</li>
            ))}
        </ul>
    );
}
